<template>
  <div
    :class="bem()"
    :style="`aspect-ratio: ${aspectRatio}`"
  >
    <div :class="bem('details')">
      <VisionStarRating
        :rating="5"
        colour="gradient"
        size="medium"
      />
      <span
        v-if="props.item.date"
        :class="bem('detail-text', {'grey':true})"
      >
        {{ $dayjs(props.item.date).format('MMMM YYYY') }}
      </span>
    </div>
    <div :class="bem('main')">
      <VisionHeading
        tag="h6"
        size="h3"
        :class="bem('quote')"
      >
        {{ props.item.quote }}
      </VisionHeading>
      <p
        v-if="props.item.secondary"
        :class="bem('secondary')"
      >
        {{ props.item.secondary }}
      </p>
    </div>
    <div :class="bem('details')">
      <p
        v-if="props.item.name"
        :class="bem('detail-text')"
      >
        {{ props.item.name }}
      </p>
      <span
        v-if="props.item.subtitle"
        :class="bem('detail-text', {'grey':true})"
      >
        {{ props.item.subtitle }}
      </span>
    </div>
  </div>
</template>

<script setup>
const bem = useBEM('CredibilityReview')

const props = defineProps({
  item: { type: Object, required: true }
})

const aspectRatio = computed(() => {
  let ratio = props.item.aspectRatio
  // Reformat incorrect aspect ratios for this type
  if (ratio === '9/16') ratio = '4/5'
  if (ratio === '16/9') ratio = '5/4'
  return ratio
})
</script>

<style lang="postcss">
.CredibilityReview {
  @apply flex flex-col gap-8
  justify-between items-stretch
  py-6 px-5 rounded-lg
  bg-grey-200;
}

.CredibilityReview__main {
  @apply flex flex-col gap-4;
}

.CredibilityReview__details {
  @apply flex justify-between items-center;
}

.CredibilityReview__detail-text {
  @apply text-xs;

  &--grey {
    @apply text-mid-grey;
  }
}
</style>